import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { AlertWarningTriangleIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useContext, useEffect, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { useGetUserQuery } from 'common';
import { useGetMeetingIntelligenceUserSettingsQuery } from 'features/meeting_intelligence';
import { TRACKING_EVENT_NAMES, useTrack } from 'hooks/analytics_events';
import { RightRailPaywallContext } from './right_rail_paywall_context';
import { UpgradeLink } from './shared';
const upgradeLinkOptions = (featureKey, onClick) => ({
  UpgradeLink: ({
    children
  }) => <UpgradeLink featureKey={featureKey} onClick={onClick}>
      {children}
    </UpgradeLink>
});
const paywallWrapperCss = "ppfervs";
const PaywallWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(paywallWrapperCss, props.className)} />;
});
const rightDivCss = "r1rc4j69";
const RightDiv = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(rightDivCss, props.className)} />;
});
export const RightRailPaywall = () => {
  // Get selectors from context - provided by feature-specific HOC
  const selectors = useContext(RightRailPaywallContext);

  // Always call hooks to satisfy rules of hooks
  const {
    data: {
      uuid: userUUID
    } = {}
  } = useGetUserQuery();
  const track = useTrack();
  const {
    data: meetingIntelligenceUserData
  } = useGetMeetingIntelligenceUserSettingsQuery();

  // Use selectors if available, otherwise use default no-op selectors
  const hadCalendlyAllTrialSelector = selectors?.hadCalendlyAllTrialSelector || (() => false);
  const isAvailableFeatureSelector = selectors?.isAvailableFeatureSelector || (() => false);
  const hadCalendlyAllTrial = useSelector(hadCalendlyAllTrialSelector);
  const featureKey = 'meeting_intelligence_nonfree';
  const isFeatureKeyAvailable = useSelector(state => isAvailableFeatureSelector(state, {
    featureKey
  }));
  const showPaywall = selectors && hadCalendlyAllTrial && !isFeatureKeyAvailable && !!meetingIntelligenceUserData?.miEnabled;
  const trackCTAClicked = () => {
    track({
      name: TRACKING_EVENT_NAMES.CTA_CLICKED,
      properties: {
        cta_destination: 'ai_paywall',
        cta_key: 'meeting_notes',
        cta_text: 'upgrade',
        action: 'interaction'
      }
    });
  };
  const onClick = () => trackCTAClicked();
  useEffect(() => {
    if (showPaywall) {
      track({
        name: TRACKING_EVENT_NAMES.CTA_SHOWN,
        properties: {
          cta_destination: 'ai_paywall',
          cta_key: 'meeting_notes',
          cta_text: 'upgrade'
        }
      });
    }
  }, [userUUID, showPaywall, track]);
  if (!showPaywall) return null;
  return <PaywallWrapper>
      <div>
        <AlertWarningTriangleIcon />
      </div>
      <RightDiv>
        <BodyText>
          {HtmlParser(I18n.t('publisher.billing.meeting_intelligence.meetings_siderail_paywall_body'), upgradeLinkOptions(featureKey, onClick))}
        </BodyText>
      </RightDiv>
    </PaywallWrapper>;
};

require("./right_rail_paywall.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./right_rail_paywall.js");